module.exports = __webpack_public_path__ + "static/img/PurpleBubble@3x.4106271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/PurpleBubble@3x.png
// module id = q66d
// module chunks = 0